import dictionary from 'config/dictionary';

// The card provider refuses anyone under 18 (its result code 5017), so the
// form says so before the claim is sent.
export const PREPAID_CARD_MINIMUM_AGE = 18;

export const formModel = [
  {
    name: 'firstName',
    elementType: 'string',
    placeholder: 'First name',
    maxLength: 255,
  },
  {
    name: 'middleName',
    elementType: 'string',
    placeholder: 'Middle names',
    optional: true,
  },
  {
    name: 'lastName',
    elementType: 'string',
    placeholder: 'Last name',
    maxLength: 255,
  },
  {
    name: 'dateOfBirth',
    elementType: 'date',
    placeholder: 'Date of birth',
    minimumAge: PREPAID_CARD_MINIMUM_AGE,
    validateOnBlur: true,
    validationErrorMessage: dictionary.prepaidCards.errors.underMinimumAge,
  },
  {
    name: 'postalAddress',
    elementType: 'address',
    placeholder: 'GBR',
    label: 'Your address',
  },
  {
    name: 'phoneNumber',
    elementType: 'string',
    placeholder: 'Phone number',
    validationRegex: '^(?:\\+44|0)[1-9]\\d{9}$',
  },
  {
    name: 'email',
    elementType: 'string',
    placeholder: 'Email address',
    maxLength: 255,
    validationRegex:
      '(([^<>()\\[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))',
  },
];

export const getFormModel = (showMiddleName = false) =>
  formModel.filter(
    ({ name }) => name !== 'middleName' || showMiddleName === true,
  );
